<template>
	<div
		v-if="concise"
		class="flex items-center justify-between gap-2 py-1 text-xs text-gray-700"
		:class="{ 'border-b border-gray-300': showBorder }"
	>
		<div class="flex min-w-0 flex-1 items-center gap-2">
			<i
				v-if="observation.categoryIcon"
				:class="observation.categoryIcon"
				class="text-gray-600"
			/>
			<span class="truncate">
				{{ observation.categoryName || "Unknown Category" }}:
				{{ observation.subcategoryName || "Unknown Subcategory" }}
			</span>
		</div>
		<SeverityBadge
			:severity="observation.severity || 5"
			class="ml-1 shrink-0"
		/>
		<ion-button
			v-if="showRemove"
			fill="clear"
			size="small"
			color="danger"
			@click="$emit('remove')"
		>
			<ion-icon :icon="closeOutline" />
		</ion-button>
	</div>
	<div
		v-else
		class="flex items-center justify-between py-2"
		:class="{ 'border-b border-gray-300': showBorder }"
	>
		<div class="flex items-center">
			<i
				v-if="observation.categoryIcon"
				:class="observation.categoryIcon"
				class="mr-3 text-gray-600"
			/>
			<div>
				<span class="text-gray-800">
					{{ observation.categoryName || "Unknown Category" }}:
					{{ observation.subcategoryName || "Unknown Subcategory" }}
				</span>
				<div class="mt-1 text-xs text-gray-600">
					Severity:
					<SeverityBadge :severity="observation.severity || 5" />
				</div>
			</div>
		</div>
		<ion-button
			v-if="showRemove"
			fill="clear"
			size="small"
			color="danger"
			@click="$emit('remove')"
		>
			<ion-icon :icon="closeOutline" />
		</ion-button>
	</div>
</template>

<script setup lang="ts">
	import { IonButton, IonIcon } from "@ionic/vue";
	import { closeOutline } from "ionicons/icons";
	import SeverityBadge from "@/components/feature/notes/ObservationSeverityBadge.vue";
	import { NoteObservationDTO } from "seedgreen-shared/dtos/NoteObservationDTO";

	interface Props {
		observation: NoteObservationDTO;
		showRemove?: boolean;
		showBorder?: boolean;
		concise?: boolean;
	}

	withDefaults(defineProps<Props>(), {
		showRemove: false,
		showBorder: false,
		concise: false,
	});

	defineEmits<{
		remove: [];
	}>();
</script>
